import React from "react";
import "./TeamAdvisoryCouncil.css";
import TeamAdvisorCard from "../TeamAdvisorCard/TeamAdvisorCard";
import { advisoryCouncilMembers } from "../teamPageData";

const TeamAdvisoryCouncil = () => {
  return (
    <section className="team-advisory-section my-lg-4 my-2">
      <div className="container">
        <div className="team-advisory-header text-center">
          <h2 className="team-advisory-title">Advisory Council</h2>
          <p className="team-advisory-copy">
            Our advisory council consists of senior practitioners across
            workforce development, healthcare, enterprise SaaS, and
            industry-specific talent transformation. They help portfolio
            companies pressure-test ontology design, accelerate enterprise
            adoption, navigate regulated industries, and open strategic doors.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {advisoryCouncilMembers.map((member) => (
            <div className="col-lg-6 col-md-6" key={member.id}>
              <TeamAdvisorCard member={member} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamAdvisoryCouncil;